export default {
  addFileName({ commit }, fileName) {
    commit('ADD_FILE_NAME', fileName);
  },
  clearFileNames({ commit }) {
    commit('CLEAR_FILE_NAMES');
  },
};
